import { transformTractsPolygon } from './transformPolygons';

export const collectTractPolygons = (tract) => {
  if (!tract) return [];

  return [
    {
      tract: tract.name,
      paths: transformTractsPolygon(tract.geojson.coordinates)
    },
    ...tract.adjacents.map(adjacent => ({
      tract: adjacent.name,
      paths: transformTractsPolygon(adjacent.geojson.coordinates)
    }))
  ];
};
